/**
 * 묶음 CSV 내보내기 (IA SC-015 '저장 목록').
 *
 * ⚠ 값에 쉼표·따옴표·줄바꿈이 들어갈 수 있다(카드명·세트명). RFC4180 대로 따옴표로 감싸고
 *   안쪽 따옴표는 두 번 쓴다 — 그냥 이어 붙이면 열이 밀려 엑셀에서 표가 깨진다.
 */
import type { CollectionGroupCard } from "../api/collectionGroup";
import i18n from "../i18n";

function cell(value: string | number | null | undefined): string {
  const s = value === null || value === undefined ? "" : String(value);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** CSV 헤더 — 사용자가 내려받는 파일이라 앱 언어를 따른다. */
const HEADER_KEYS = [
  "export.header.cardName",
  "export.header.set",
  "export.header.number",
  "export.header.language",
  "export.header.rarity",
  "export.header.price",
  "export.header.currency",
  "export.header.quantity",
];

export function buildGroupCsv(
  groupName: string,
  cards: CollectionGroupCard[],
  now: Date,
): string {
  const lines = [
    `# ${groupName} · ${now.toISOString().slice(0, 10)}`,
    HEADER_KEYS.map((k) => cell(i18n.t(k))).join(","),
  ];
  for (const c of cards) {
    lines.push([
      cell(c.card.name),
      cell(c.card.cardsetName),
      cell(c.card.number),
      cell(c.card.language),
      cell(c.card.rarity),
      cell(c.currentPrice?.amount ?? ""),
      cell(c.currentPrice?.currency ?? ""),
      cell(c.owned ? "Y" : "N"),
    ].join(","));
  }
  return lines.join("\r\n");
}

export function groupCsvFilename(groupName: string, now: Date): string {
  // 파일명에 못 쓰는 글자를 걷어낸다 — 남기면 브라우저가 통째로 다른 이름을 붙인다.
  const safe = groupName.replace(/[\\/:*?"<>|]/g, "_").trim() || "collection";
  return `${safe}_${now.toISOString().slice(0, 10)}.csv`;
}
